module.exports = __webpack_public_path__ + "img/client-resource.c5a3b187.png";